// tslint:disable
export enum NameType {
    /**
     * @description UNKNOWN
     */
    UNKN = 0,
    /**
     * @description LEGAL NAME
     */
    LGLNM = 1,
    /**
     * @description MAIDEN NAME
     */
    MDNNM = 2,
    /**
     * @description MARRIED NAME
     */
    MRDNM = 3,
    /**
     * @description PROFESSIONAL NAME
     */
    PRNM = 4,
    /**
     * @description DOING BUSINESS AS
     */
    DBA = 5,
    /**
     * @description ALSO KNOW AS
     */
    AKA = 6,
    /**
     * @description NICK NAME
     */
    NKNM = 7,
}
